Vue.filter('formattedSize', function (size) {
    if ( ! size) return ''

    return bytes(parseInt(size));
})